// APP TEXT
export const APP_TITLE = 'ERP App';
export const APP_DESCRIPTION = 'React TypeScript Material-UI boilerplate by Welcome, Developer.';
export const FOOTER_TEXT = `${new Date().getFullYear()} Proudly made by Anish Raju`;
// PAGES TITLE
export const PAGE_TITLE_HOME = 'Home';
export const PAGE_TITLE_DASHBOARD = 'Dashboard';
export const PAGE_TITLE_GH_PRIVATE = 'GitHub Private';
export const PAGE_TITLE_GH_PUBLIC = 'GitHub Public';
export const PAGE_TITLE_CODE = 'Code Editor';
export const PAGE_TITLE_SETTINGS = 'Settings';
export const PAGE_TITLE_PREFERENCES = 'Preferences';
// UI CONSTANTS
export const FOOTER_HEIGHT = 30;
export const HEADER_HEIGHT = 60;
export const DRAWER_WIDTH = 250;
// APP THEME
export const DARK_MODE_THEME = 'dark';
export const LIGHT_MODE_THEME = 'light';
// URL
export const BASE_URL = 'https://api.raselindia.in/'
//export const BASE_URL = 'https://localhost:44391/'